const pubsub = () => ({
  emitMarketplaceEvent: (type, eventData) => window
    .dispatchEvent(new CustomEvent(type, { detail: eventData })),
  subscribeToMarketplaceEvents: (handlers) => {
    if (!handlers || Object.keys(handlers).length === 0) {
      return -1;
    }
    Object.keys(handlers)
      .forEach((handler) => {
        if (handlers[handler] && handlers[handler] instanceof Function) {
          window.addEventListener(handler, handlers[handler], 0);
        }
      });
    return handlers;
  },
  unsubscribeFromMarketplaceEvents: (handlers) => {
    if (!handlers || Object.keys(handlers).length === 0) {
      return -1;
    }
    Object.keys(handlers)
      .forEach((handler) => {
        if (handlers[handler] && handlers[handler] instanceof Function) {
          window.removeEventListener(handler, handlers[handler], 0);
        }
      });

    return null;
  },
});

export default pubsub;

window.emitMarketplaceEvent = pubsub().emitMarketplaceEvent;
window.subscribeToMarketplaceEvents = pubsub().subscribeToMarketplaceEvents;
window.unsubscribeFromMarketplaceEvents = pubsub().unsubscribeFromMarketplaceEvents;
